export default __webpack_public_path__ + "static/bCover8K-0973a8fbee418b866c70235cffa7001f.png";